var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDollar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_623_5249)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 9.50016,
    cy: 9.50012,
    r: 7.91667,
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.2502 4.75012C10.2502 4.33591 9.91436 4.00012 9.50015 4.00012C9.08594 4.00012 8.75015 4.33591 8.75015 4.75012V5.61613C8.32117 5.66604 7.87581 5.78166 7.4932 6.01997C7.00553 6.32372 6.65561 6.80781 6.57725 7.46758C6.51843 7.96272 6.57108 8.41765 6.75709 8.81918C6.94402 9.22268 7.23771 9.51195 7.56061 9.71984C8.15388 10.1018 8.93195 10.2545 9.52124 10.3701L9.54854 10.3754L9.59915 10.3853L9.59916 10.3854C9.90183 10.4447 10.1679 10.4969 10.4088 10.562C10.6646 10.6311 10.8411 10.7022 10.9579 10.7758C11.0639 10.8425 11.0938 10.8935 11.1074 10.9298C11.1237 10.9731 11.1517 11.0923 11.0885 11.3505C11.0576 11.4767 10.9737 11.5975 10.7399 11.7082C10.4896 11.8267 10.1247 11.9003 9.68112 11.9143C8.77584 11.943 7.83862 11.7192 7.47482 11.5275C7.10837 11.3344 6.65476 11.4749 6.46165 11.8413C6.26853 12.2078 6.40904 12.6614 6.77549 12.8545C7.23592 13.0971 7.97377 13.2926 8.75015 13.3748V14.2501C8.75015 14.6643 9.08594 15.0001 9.50015 15.0001C9.91436 15.0001 10.2502 14.6643 10.2502 14.2501V13.3737C10.6406 13.3249 11.0315 13.2298 11.3817 13.064C11.9056 12.816 12.3795 12.3851 12.5455 11.7072C12.6571 11.2514 12.6642 10.8082 12.5115 10.402C12.3561 9.98865 12.069 9.70285 11.7574 9.50658C11.4567 9.31719 11.1152 9.1991 10.8002 9.11396C10.506 9.03446 10.1904 8.97264 9.90246 8.91625L9.83747 8.90351C9.17246 8.77297 8.68752 8.66138 8.37261 8.45863C8.23681 8.3712 8.16195 8.28323 8.11813 8.18865C8.0734 8.09209 8.03309 7.92808 8.06678 7.6445C8.0879 7.46669 8.15895 7.37248 8.28623 7.29319C8.44627 7.19351 8.7116 7.11565 9.08769 7.09137C9.83778 7.04295 10.7456 7.22394 11.3154 7.41559C11.708 7.54764 12.1333 7.33642 12.2654 6.94382C12.3974 6.55121 12.1862 6.1259 11.7936 5.99385C11.3871 5.85712 10.8373 5.72111 10.2502 5.6451V4.75012Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_623_5249"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19,
    height: 19,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDollar);
export default __webpack_public_path__ + "static/media/dollar.9156d349d109c13c7e9b573637e63221.svg";
export { ForwardRef as ReactComponent };